"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CustomIconOrImage = _interopRequireDefault(require("../../../shared/CustomIconOrImage"));
var _r10SourceLibrary = require("r10-source-library");
var _BaseComponents = require("../../../StyledComponents/BaseComponents");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Container = (0, _styledComponents.default)((0, _BaseComponents.GrayBackground)(`div`))`
  padding: 16px 16px;
  margin: 16px 0px;
  display: flex;

  gap: 16px;
`;
const EntelPlanDisclaimer = _ref => {
  let {
    text
  } = _ref;
  if (!text) return null;
  return /*#__PURE__*/_react.default.createElement(Container, {
    "data-test-id": "additional-plan-disclaimer"
  }, /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
    name: "info-circle"
  }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    appearance: "secondary"
  }, text));
};
var _default = EntelPlanDisclaimer;
exports.default = _default;